import { DeviceNotCenterControl, Header } from "components"
export const DeviceNotControl = () => {
 return (
  <div>
   <div className="z-10 relative">
    <Header />
   </div>
   <DeviceNotCenterControl />
  </div>
 )
}
